import Vue from 'vue';
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import weekOfYear from "dayjs/plugin/weekOfYear";
import zh from "dayjs/locale/zh-cn";
dayjs.extend(relativeTime);
dayjs.extend(weekOfYear)
dayjs.locale(zh);

/**
 * 文档地址
 * @see https://day.js.org/docs/zh-CN/plugin/relative-time
 * 距离现在的相对时间 .fromNow(withoutSuffix?: boolean)
 * 返回 string 距离现在的相对时间
 */
Vue.prototype.$dayjs = dayjs;


// WEBPACK FOOTER //
// ./src/plugins/day.js